<template>
  <div class="inicio">
    <Header
      style="background: linear-gradient(307deg, #f98043 0%, #c90000 100%);"
    />
    <div class="contentBox">
      <!-- banner模块 -->
      <div class="banner">
        <!-- 圆形信息 -->
        <div class="titleInfo">
          ¡Obtén <br />
          hasta <br />
          S/5000 en <br />
          instantes!
        </div>
        <!-- banner图片 -->
        <img
          height="100%"
          src="../../assets/image/newImage/banner.png"
          alt=""
        />
        <!-- 下载按钮 -->
        <div class="text">
          <h2 style="margin-bottom:22px">Descárgalo en</h2>
          <a
            href="https://www.credisol.pe/credisol.apk"
          >
            <!-- <i class="el-icon-download"></i>
            <p>Haga clic para descargar</p> -->
            <img src="@/assets/image/Inicio/two.png" alt="" />
          </a>
        </div>
      </div>

      <!-- prestamo 流程模块 -->
      <div class="processBox">
        <!-- 流程图片盒子 -->
        <div class="firstBox">
          <h2>
            ¿Cómo solicitar <br />
            un <span>préstamo</span> ?
          </h2>
          <img
            height="100%"
            src="../../assets/image/newImage/prestamo.png"
            alt=""
          />
        </div>
        <!-- 分割线 -->
        <div class="divider"></div>
        <!-- process流程 -->
        <div class="rightBox">
          <div class="listBox">
            <div>
              <img src="../../assets/image/newImage/1icon.png" alt="" />
            </div>
            <p>Descarga la aplicación</p>
          </div>
          <div class="listBox">
            <div>
              <img src="../../assets/image/newImage/2icon.png" alt="" />
            </div>
            <p>Llena tus datos personales</p>
          </div>
          <div class="listBox">
            <div>
              <img src="../../assets/image/newImage/3icon.png" alt="" />
            </div>
            <p>
              ¡Listo, el préstamo llegará en <br />
              minutos!
            </p>
          </div>
        </div>
      </div>

      <!-- 四大模块 -->
      <div class="foureBox">
        <div>
          <img src="../../assets/image/newImage/1img.png" alt="" />
          <div></div>
          <p>
            Aprobación en <br />
            tres minutos
          </p>
        </div>
        <div>
          <img src="../../assets/image/newImage/2img.png" alt="" />
          <div></div>
          <p>
            Sin gastos <br />
            ocultos
          </p>
        </div>
        <div>
          <img src="../../assets/image/newImage/3img.png" alt="" />
          <div></div>
          <p>
            Depósito directo <br />
            a tu cuenta
          </p>
        </div>
        <div>
          <img src="../../assets/image/newImage/4img.png" alt="" />
          <div></div>
          <p>
            Datos <br />
            personales <br />
            protegidos
          </p>
        </div>
      </div>

      <!-- download Box -->
      <div class="downloadBoxFoot">
        <h2>¡Descarga la aplicación y pide tu préstamo ahora!</h2>
        <div></div>
        <a
          href="https://www.credisol.pe/credisol.apk"
        >
          <!-- <i style="font-size: 45px;width:65px;height:65px" class="el-icon-download"></i>
          <p style="font-size: 33px">Haga clic para descargar</p> -->
          <img src="@/assets/image/Inicio/playBtn.png" alt="" />
        </a>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/newHeader.vue";
import Footer from "../../components/newFooter.vue";
export default {
  name: "Inicio",
  components: {
    Header,
    Footer,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.inicio {
  width: 100%;
  .banner {
    display: flex;
    width: 100%;
    height: 520px;
    align-items: center;
    padding-left: 19%;
    background: #ece8e5;
    .titleInfo {
      width: 379px;
      height: 379px;
      padding-top: 35px;
      text-align: center;
      font-size: 55px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: #e8e8e9;
      border-radius: 50%;
      background: linear-gradient(306deg, #f98043 0%, #c90000 100%);
    }
    .text {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #c90000;
      margin-top: 220px;
    }
  }
  .downLoadBox {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 15px;
    i {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30%;
      color: #c90000;
      text-align: center;
      font-size: 30px;
      background-color: #ccc;
      width: 55px;
      height: 55px;
      border-radius: 50%;
    }
    p {
      width: 70%;
      font-size: 16px;
      font-weight: 700;
      text-align: center;
      color: #333;
    }
  }

  .processBox {
    width: 100%;
    height: 500px;
    display: flex;
    align-items: center;
    padding-left: 20%;
    background: linear-gradient(310deg, #f98043 0%, #c90000 100%);
    .firstBox {
      position: relative;
      height: 100%;
      padding-top: 30px;
      h2 {
        font-size: 45px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #ffc029;
        span {
          color: #fff;
        }
      }
      img {
        position: absolute;
        bottom: 5px;
        width: 310px;
        height: 310px;
      }
    }
    .divider {
      width: 1px;
      height: 252px;
      margin: 0 114px 0 140px;
      border: 4px solid #ffc029;
    }
    .rightBox {
      padding-top: 85px;
      .listBox {
        display: flex;
        align-items: center;
        margin-bottom: 60px;
        div {
          width: 90px;
          text-align: center;
          margin-right: 35px;
        }
        p {
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
  }

  .foureBox {
    width: 100%;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    & > div {
      width: 265px;
      height: 336px;
      background: linear-gradient(314deg, #f98043 0%, #db2810 100%);
      border-radius: 40px;
      margin-right: 50px;
      text-align: center;
      padding-top: 25px;
      div {
        width: 150px;
        height: 3px;
        background-color: #ffc029;
        margin: 10px auto 23px;
      }
      &:last-child {
        margin-right: 0;
      }
      p {
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  .downloadBoxFoot {
    width: 100%;
    height: 500px;
    padding-top: 70px;
    background: #ece8e5;
    text-align: center;
    h2 {
      font-size: 42px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: #c90000;
    }
    div {
      width: 612px;
      height: 3px;
      background-color: #ffc029;
      margin: 70px auto;
    }
  }
}
</style>
